import { Pipe, PipeTransform } from "@angular/core";
import { InfoCenterFile } from "../models/InfoCenterFile";
import { User } from "../models/User";

@Pipe({
  name: "sort",
  pure:false
})
export class ArraySortPipe implements PipeTransform {
  transform(array: any, field: string): any[] {
    if (!Array.isArray(array)) {
      return;
    }
    array.sort((a: any, b: any) => {
      if (a[field] < b[field]) {
        return -1;
      } else if (a[field] > b[field]) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}

@Pipe({
  name: 'UserFilter',
  pure: true
})
export class UserFilter implements PipeTransform {
  transform(userList: Array<User>, filterText: string) {
    if (filterText.length > 0) {
      return userList.filter(x => (x.FirstName + " " + x.LastName).toLowerCase().indexOf(filterText.toLowerCase()) >= 0 || x.Email.toLowerCase().indexOf(filterText.toLowerCase()) >= 0);
    }
    else {
      return userList;
    }
  }
}

@Pipe({ name: "CategoryFilter", pure: true })
export class CategoryFilter implements PipeTransform {
  transform(catList: Array<InfoCenterFile>, filterBy: number, fileName: string) {
    var retList = new Array<InfoCenterFile>();
    if (filterBy >= 0 && catList && catList.length > 0) {
      retList = catList.filter(x => x.Category == filterBy);
    }
    else {
      retList = catList;
    }

    if (fileName.length > 0) {
      retList = retList.filter(x => x.FileName.toLowerCase().indexOf(fileName.toLowerCase()) >= 0);
    }

    return retList;
  }
}

@Pipe({ name: 'range', pure: true })
export class RangePipe implements PipeTransform {
  transform(value: number): number[] {
    var retArray = [];
    for (var i = 0; i < value; i++) {
      retArray.push(i);
    }
    return retArray;
  }
}

